import React from "react";
import { BrowserRouter, Route, Switch} from "react-router-dom";
import SignIn from "./pages/SignIn";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";
import Role from "./pages/Role";
import PublicRoute from "./hooks/PublicRoute";
import PrivateRoute from "./hooks/PrivateRoute";
import Permission from "./pages/Permission";
import User from "./pages/User";
import Sarlaft from "./pages/Sarlaft";

import SarlaftPeru from "./pages/SarlaftPeru";
import SarlaftChile from "./pages/SarlaftChile";
import SarlaftVenezuela from "./pages/SarlaftVenezuela";
import SarlaftFD from "./pages/SarlaftFD";

import JuridicalPerson from "./pages/JuridicalPerson";
import NaturalPerson from "./pages/NaturalPerson";
import Signature from "./pages/Signature";

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <PublicRoute path="/" exact restricted={true} component={SignIn} />
      <Route path="/solicitud/colombia" exact restricted={false} component={Sarlaft} />
      <Route path="/solicitud/peru" exact component={SarlaftPeru} />
      <Route path="/solicitud/chile" exact component={SarlaftChile} />
      <Route path="/solicitud/fuerzadelta" exact component={SarlaftFD} />
      <Route path="/solicitud/venezuela" exact component={SarlaftVenezuela} />
      <Route path="/firmar" exact restricted={false} component={Signature} />
      <PublicRoute path="/signIn" exact restricted={true} component={SignIn} />
      <PrivateRoute
        exact
        path="/solicitud"
        component={Sarlaft}
        when="feature:read-sarlaft"
      />
      <PublicRoute
        exact
        path="/dashboard"
        component={Dashboard}
        when="feature:see-dashboard"
      />
      <PrivateRoute
        exact
        path="/juridicalPersons"
        component={JuridicalPerson}
        when="feature:read-juridicalPersons"
      />
      <PrivateRoute
        exact
        path="/naturalPersons"
        component={NaturalPerson}
        when="feature:read-naturalPersons"
      />
      <PrivateRoute
        exact
        path="/roles"
        component={Role}
        when="feature:read-role"
      />
      <PrivateRoute
        exact
        path="/permissions"
        component={Permission}
        when="feature:read-permission"
      />
      <PrivateRoute
        exact
        path="/users"
        component={User}
        when="feature:read-user"
      />
      <Route path="*" component={NotFound} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
